import React from "react";
import { useStoreStatus, opensLabel } from "@/context/StoreContext";

export default function StoreStatusBadge() {
  const { status } = useStoreStatus();
  if (!status) return null;
  const open = status.is_open;
  return (
    <span data-testid="store-status-badge" data-open={open} title={open ? `Open until ${status.closes_at}` : opensLabel(status)}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold whitespace-nowrap ${open ? "bg-biga-green text-white" : "bg-red-600 text-white"} shadow-sm`}>
      <span className={`w-2 h-2 rounded-full ${open ? "bg-white animate-pulse" : "bg-white/80"}`} />
      {open ? "Open" : "Closed"}
      {!open && <span className="hidden sm:inline md:hidden xl:inline font-semibold opacity-80" data-testid="store-next-open">· {opensLabel(status)}</span>}
    </span>
  );
}
